import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonComponent } from "../../common/common-component";
import { ContentBlockComponent } from "../../component/content-block/content-block.component";
import { ImageSliderComponent } from "../../component/image-slider/image-slider.component";
import { JsonPipe, NgForOf, NgIf } from "@angular/common";
import { BehaviorSubject, map, mergeMap, Subject, Subscription, takeUntil, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { NotificationService } from "../../common/service/notification.service";
import { ConfigService } from "../../common/service/config.service";
import { DateFnsModule } from "ngx-date-fns";
import { parseJSON } from "date-fns";
import { DefaultImageDirective } from "../../common/directive/default-image.directive";

@Component({
  selector: 'section#gallery-search',
  standalone: true,
  imports: [
    ContentBlockComponent,
    ImageSliderComponent,
    NgIf,
    NgForOf,
    DateFnsModule,
    DefaultImageDirective,
    JsonPipe
  ],
  templateUrl: './gallery-search.component.html'
})
export class GallerySearchComponent extends CommonComponent implements OnInit, OnDestroy {

  private subscription: Subscription | undefined;
  protected override limit = 10;
  public assets: Array<{ url: string }> = [];
  public jobId: any;
  public selectedJobs: any = {};

  private page$ = new BehaviorSubject(1);
  private completed: Subject<any> = new Subject();
  private page: number = 1;
  private triggered: boolean = false;
  defaultImage: string = '/assets/images/blank.png';


  constructor(
    private httpClient: HttpClient,
    private notificationService: NotificationService,
    private configService: ConfigService
  ) {
    super();
  }

  ngOnInit(): void {

    this.subscription =  this.configService.config$.pipe(
      tap(config => this.config = config),
      mergeMap(() => this.page$.asObservable()),
      takeUntil(this.completed),
      tap((page) => this.page = page),
      mergeMap(() => this.httpClient.post<Array<{assets: Array<any>, id: string, createdAt: any, status: string}>>(environment.api_v2_url + '/gallery-search?limit=' + this.limit + '&page=' + this.page, { event_ids: [this.config.id] })),
      map((items: Array<{ assets: Array<any>, id: string, createdAt: any, status: string }>): Array<{
        assets: Array<any>,
        id: string,
        createdAt: any,
        status: string
      }> => items.map(item => {
        if(typeof item.createdAt === 'string') {
          return { ...item, createdAt: parseJSON(item.createdAt) };
        }
        else {
          return item;
        }
      }))
    ).subscribe((items: Array<{assets: Array<any>, id: string, createdAt: Date, status: string}>) => {

      if (items.length === 0) {
        this.completed.next(true);
        return;
      }

      this.jobs = this.jobs.concat(items.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime()));

      for (let job of this.jobs) {

        this.selectedJobs[job.id] = {
          current: 0,
          status: this.filterOutputOnly(job.assets)[0].status || 'visible'
        };

      }

      // console.log(this.selectedJobs);
      this.triggered = false;
    });
  }

  ngOnDestroy(): void {
    if(this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  getQRCode(id: string) {
    const url = window.location.toString().replace('gallery-search', 'result/' + id + '?qr=1');
    return `https://api.qrserver.com/v1/create-qr-code/?size=600x600&qzone=5&data=${encodeURIComponent(url)}`
  }

  showQrCode(id: string) {
    this.jobId = id;
  }

  hideQrCode() {
    this.jobId = undefined;
  }



  isSelected(id: string, i: number): boolean {

    // console.log(this.selectedJobs);

    if(this.selectedJobs.hasOwnProperty(id)) {
      return this.selectedJobs[id]['current'] === i;
    }
    else {
      return i === 0;
    }

  }

  onScrollingFinished() {
    if ( ! this.triggered) {
      this.page$.next(this.page + 1);
      this.triggered = true;
    }
  }

  onScroll($event: any) {
    // console.log('scroll', $event);
    const target = $event.target as HTMLElement;
    if (target.scrollHeight - target.clientHeight - target.scrollTop < 150) {
      this.onScrollingFinished();
    }
  }

  toggle(id: string) {

    if(this.selectedJobs.hasOwnProperty(id)) {
      for(let job of this.jobs) {
        if(job.id === id) {
          let asset = this.filterOutputOnly(job.assets)[this.selectedJobs[id]['current']];
          let assetId = asset.id;
          this.httpClient.patch(environment.api_v2_url + '/job/' + id + '/asset/' + assetId, {}).subscribe(() => {
            if(this.selectedJobs[id]['status'] === 'hidden') {
              this.selectedJobs[id]['status'] = 'visible';
              asset['status'] = 'visible';
            }
            else {
              this.selectedJobs[id]['status'] = 'hidden';
              asset['status'] = 'hidden';
            }
          });
        }
      }
    }

  }

  filterOutputOnly(assets: Array<{ assetType: string, status: string }>): Array<any> {
    return assets.filter(asset => asset.assetType === 'output');
  }

  getStatus(selectedJob: any) {
    if(selectedJob) {
      return selectedJob['status'];
    }
    else {
      return 'n/a';
    }
  }

  next(id: string) {
    let i = this.selectedJobs[id]['current'];
    for (let job of this.jobs) {
      if (job.id === id) {
        this.selectedJobs[id] = {
          current: (i + 1) % this.filterOutputOnly(job.assets).length,
          status: this.filterOutputOnly(job.assets)[(i + 1) % this.filterOutputOnly(job.assets).length].status
        };
      }
    }
  }

  previous(id: string) {
    let i = this.selectedJobs[id]['current'];

    for (let job of this.jobs) {
      if (job.id === id) {
        if (i == 0) {
          i = this.filterOutputOnly(job.assets).length;
        }
        this.selectedJobs[id] = {
          current: (i - 1) % this.filterOutputOnly(job.assets).length,
          status: this.filterOutputOnly(job.assets)[(i - 1) % this.filterOutputOnly(job.assets).length].status
        };
      }
    }
  }
}
